import { getQueryClient } from "@/services/get-query-client";
import type { TAvatarSettings } from "@/types/TAvatarSettings";
import { authenticatedFetchJson } from "@/services/utils/authenticatedFetch";

export default async function updateSettings(settings: TAvatarSettings): Promise<TAvatarSettings> {
  const queryClient = getQueryClient();
  
  const savedSettings = await authenticatedFetchJson<TAvatarSettings>("/api/settings", {
    method: "POST",
    body: JSON.stringify(settings),
  });
  
  // Invalidate settings queries to ensure data is fresh
  await queryClient.invalidateQueries({ queryKey: ["settings"] });
  
  return savedSettings;
}